import { render } from "./App.vue?vue&type=template&id=cb6f7cf4&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=cb6f7cf4&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__